module.exports = __webpack_public_path__ + "img/home-world-best-banner-04.eb40acf6.jpg";